import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import saveCardToken from '../../actions/saveCardToken';
import '../../util/modalCSS.css'
import { Checkbox, FormControlLabel } from '@material-ui/core';
import getIFrameKey from '../../actions/getIFrameKey';

export default (props) => {
    let [check] = global.get('check');
    let [restaurant] = global.get('restaurant');
    const [isOneTimeUseCard, setIsOneTimeUseCard] = useState(false)
    const [transactionSetupId, setTransactionSetupId] = useState(null)
    const [loading, setLoading] = useState(true)

    const fetch = async () => {
        const myTotal = global.f(check, 'myTotals.youPay', 0)
        const resp = await getIFrameKey(restaurant._id, myTotal, localStorage.accountId)
        if (resp.success) {
            setTransactionSetupId(resp.data)
        }
    }

    useEffect(()=> {
        fetch()
    },[restaurant])

	const c = makeStyles((theme) => ({
		label: {
			fontSize: 14,
			fontWeight: 400,
			color: 'rgba(0, 0, 0, 0.6)',
			textAlign: 'center',
			marginBottom: 8,
		},
		nameInput: {
			width: 213,
			height: 44,
			position: 'relative',
			left: '50%',
			transform: 'translateX(-50%)',
			marginRight: 'auto',
			marginLeft: 'auto',
			border: '1px solid #999999',
			borderRadius: 0,
			padding: 6,
			fontSize: 16,
			fontWeight: '500',
			color: 'rgb(97,97,97)',
			marginBottom: 8,
			appearance: 'none'
		},
		formContent: {
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
			maxWidth: '350px',
            flexDirection:'column',
            textAlign:'center',
		}
	}))();

    useEffect(()=>{
        window.document.addEventListener('myCustomEvent', handleEvent, false)
        async function handleEvent(e) {
            const data = e.detail;
            const zipCode = document.querySelector('#zipCode').value
            const resp = await saveCardToken('generic', data.PaymentAccountID, data.LastFour, 'worldpay', null, null, null, null, zipCode, isOneTimeUseCard);
            if (resp.card) {
                props.next(resp.card)	
            }
        }       
    },[])

	return (
		<div style={{display:'flex', justifyContent:'center'}}>	
			<div className={c.separator}></div>

			<div className={c.formContent} style={{opacity: loading ? 0 : 1, paddingTop:4}}>
                <div style={{display:'flex', width:'100%', padding:'4px 4px 4px 4px', justifyContent:'center', paddingLeft:27}}>
                    <div style={{color: '#333333', fontSize:'13px', fontWeight:'bold', width:74, display:'flex', flexBasis: '60px', alignItems:'center', justifyContent:'flex-end', width:87, paddingRight:4, textAlign:'right', marginBottom:'2px'}}>
                        Name on card:
                    </div>
                    <div style={{width:222, paddingLeft:9}}>
                        <input type='text' id="customerFullName" style={{width:'214px', height:42, border:'1px solid #c7c1c6', borderColor:'rgb(96 92 95) #c7c1c6 #c7c1c6 rgb(96 92 95)', padding:6}}/>
                    </div>
                </div>

                <div style={{display:'flex', width:'100%', paddingTop:4, justifyContent:'center', paddingLeft:23}}>
                    <div style={{color: '#333333', fontSize:'13px', fontWeight:'bold', width:74, display:'flex', flexBasis: '60px', alignItems:'center', justifyContent:'flex-end', width:87, paddingRight:4, textAlign:'right'}}>
                        Zip code:
                    </div>
                    <div style={{width:222, paddingLeft:9}}>
                        <input type='tel' id="zipCode" name="zipCode" style={{width:'214px', height:42, border:'1px solid #c7c1c6', borderColor:'rgb(96 92 95) #c7c1c6 #c7c1c6 rgb(96 92 95)', padding:6}}/>
                    </div>
                </div>

                {transactionSetupId && 
                    <iframe title="worldpay" id='worldpayIFrame' onLoad={()=> setLoading(false)} 
                        src={`https://certtransaction.hostedpayments.com/?TransactionSetupID=${transactionSetupId}`} 
                        style={{width:'100%', height:'156px', border:'none', display: loading? false : true}}>
                    </iframe>
                }
                
                <div style={{width:'100%', display:'flex', justifyContent:'center'}}>
                    <FormControlLabel
                        label={<span style={{fontSize:'13px', alignSelf:'center'}}>Save card</span>}
                        control={
                            <Checkbox checked={!isOneTimeUseCard} onChange={()=>setIsOneTimeUseCard(!isOneTimeUseCard)} color="primary" inputProps={{ 'aria-label': 'Retain card for future purchases' }}/>
                        }
                    />
                </div>
			</div>

		</div>
	);
};